"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRESCRIPTION_FREQUENCIES () {
        return PRESCRIPTION_FREQUENCIES;
    },
    get PRESCRIPTION_FREQUENCY_KEYS () {
        return PRESCRIPTION_FREQUENCY_KEYS;
    },
    get PrescriptionFrequencySchema () {
        return PrescriptionFrequencySchema;
    }
});
const _zod = require("zod");
const PRESCRIPTION_FREQUENCY_KEYS = [
    'OD',
    'BID',
    'TID',
    'QID',
    'Q6H',
    'HS',
    'PRN',
    'QWK'
];
const PrescriptionFrequencySchema = _zod.z.enum(PRESCRIPTION_FREQUENCY_KEYS);
const PRESCRIPTION_FREQUENCIES = [
    {
        key: 'OD',
        label: 'Once daily (OD)',
        perDay: 1
    },
    {
        key: 'BID',
        label: 'Twice daily (BID)',
        perDay: 2
    },
    {
        key: 'TID',
        label: 'Three times daily (TID)',
        perDay: 3
    },
    {
        key: 'QID',
        label: 'Four times daily (QID)',
        perDay: 4
    },
    {
        key: 'Q6H',
        label: 'Every 6 hours',
        perDay: 4
    },
    {
        key: 'HS',
        label: 'At bedtime (HS)',
        perDay: 1
    },
    {
        key: 'PRN',
        label: 'As needed (PRN)',
        perDay: null
    },
    {
        key: 'QWK',
        label: 'Once weekly',
        perDay: 1 / 7
    }
];
